<script setup>
import { computed, ref } from "vue";
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import { useStore } from "vuex";
import moment from "moment";

const store = useStore();
const title = ref("Announcement");
const items = ref([
  {
    text: "Home",
    href: "/",
  },
  {
    text: "Announcement",
    active: true,
  },
]);

const currentTab = ref(0);
const announcementPerPage = ref(10);
const activePage = computed(
  () => store.state.announcement.active_pagination.page
);
const activeLastPage = computed(
  () => store.state.announcement.active_pagination.last_page
);
const archivePage = computed(
  () => store.state.announcement.archive_pagination.page
);
const archiveLastPage = computed(
  () => store.state.announcement.archive_pagination.last_page
);
const activeAnnouncements = computed(() => store.state.announcement.active);
const archiveAnnouncements = computed(() => store.state.announcement.archive);

const userRoles = computed(() => JSON.parse(localStorage.getItem("roles")));
const roleExist = (slug) => {
  if (userRoles.value && userRoles.value.length) {
    return userRoles.value.some((obj) => obj.slug === slug);
  }

  return false;
};

const getActiveAnnouncement = async (dt) => {
  await store.dispatch("announcement/getActiveAnnouncements", {
    page: dt.page,
    pageSize: dt.per_page,
    sortColumn: "updated_at",
    search: dt.search,
    orderBy: "desc",
  });
};

const getArchiveAnnouncement = async (dt) => {
  await store.dispatch("announcement/getArchiveAnnouncements", {
    page: dt.page,
    pageSize: dt.per_page,
    sortColumn: "updated_at",
    search: dt.search,
    orderBy: "desc",
  });
};

const clearAnnouncement = async () => {
  await store.dispatch("announcement/clearAnnouncements");

  getActiveAnnouncement({
    page: activePage.value,
    per_page: announcementPerPage.value,
    search: null,
  });
  getArchiveAnnouncement({
    page: archivePage.value,
    per_page: announcementPerPage.value,
    search: null,
  });
};

clearAnnouncement();
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
      <div class="d-flex mb-4 justify-content-between">
        <div></div>
        <div>
          <router-link
            v-if="
              roleExist('list-announcement') ||
              roleExist('add-announcement') ||
              roleExist('edit-announcement') ||
              roleExist('delete-announcement')
            "
            to="/announcement/list"
            class="btn btn-primary right"
          >
            <i
              class="ri-file-list-2-line label-icon align-middle fs-16 me-2"
            ></i>
            Announcement List
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col lg-12">
          <b-card no-body>
          <b-tabs v-model="currentTab" content-class="mt-3" card fill>
            <!-- Active Announcements Tab -->
            <b-tab title="Active Announcements">
              <b-list-group>
                <b-list-group-item
                  v-for="announcement in activeAnnouncements"
                  :key="announcement.id"
                >
                  <h5>{{ announcement.title }}</h5>
                  <h6>
                    {{
                      moment(announcement.created_at).format(
                        "ddd, D MMM YYYY hh:mm:ss A"
                      )
                    }}
                  </h6>
                  <p>{{ announcement.description }}</p>
                </b-list-group-item>
              </b-list-group>
              <div class="d-flex mb-4 justify-content-between">
                <div></div>
                <div>
                  <b-button
                    v-if="activePage != activeLastPage"
                    variant="primary"
                    class="mt-3 btn btn-primary right"
                    @click="
                      getActiveAnnouncement({
                        page: activePage + 1,
                        per_page: announcementPerPage,
                        search: null,
                      })
                    "
                  >
                    View More
                  </b-button>
                </div>
              </div>
              <b-list-group v-if="activeAnnouncements.length == 0">
                No active announcement found
              </b-list-group>
            </b-tab>

            <!-- Archived Announcements Tab -->
            <b-tab title="Archived Announcements">
              <b-list-group>
                <b-list-group-item
                  v-for="announcement in archiveAnnouncements"
                  :key="announcement.id"
                >
                  <h5>{{ announcement.title }}</h5>
                  <h6>
                    {{
                      moment(announcement.created_at).format(
                        "ddd, D MMM YYYY hh:mm:ss A"
                      )
                    }}
                  </h6>
                  <p>{{ announcement.description }}</p>
                </b-list-group-item>
              </b-list-group>
              <div class="d-flex mb-4 justify-content-between">
                <div></div>
                <div></div>
                <b-button
                  v-if="archivePage != archiveLastPage"
                  variant="primary"
                  class="mt-3 btn btn-primary right"
                  @click="
                    getArchiveAnnouncement({
                      page: archivePage + 1,
                      per_page: announcementPerPage,
                      search: null,
                    })
                  "
                >
                  View More
                </b-button>
              </div>
              <b-list-group v-if="archiveAnnouncements.length == 0">
                No archive announcement found
              </b-list-group>
            </b-tab>
          </b-tabs>
          </b-card>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>
